import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FiGrid,
  FiBookOpen,
  FiCreditCard,
  FiLayers,
  FiKey,
} from "react-icons/fi";

const ToolsHeader = ({
  title = "Business Tools",
  subtitle = "Manage your Khatabooks, Cashbooks, Project Ledgers, and Leases in one place.",
  actions,
  basePath = "/partner/tools",
}) => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Determine base prefix based on current pathname (partner, customer, admin, or standalone)
  let resolvedBase = basePath;
  if (currentPath.startsWith("/partner/tools") || currentPath.startsWith("/partner/")) {
    resolvedBase = "/partner/tools";
  } else if (currentPath.startsWith("/customer/tools") || currentPath.startsWith("/customer/")) {
    resolvedBase = "/customer/tools";
  } else if (currentPath.startsWith("/admin/tools") || currentPath.startsWith("/admin/")) {
    resolvedBase = "/admin/tools";
  } else if (currentPath.startsWith("/tools")) {
    resolvedBase = "/tools";
  }

  const navItems = [
    {
      to: resolvedBase,
      label: "Overview",
      icon: FiGrid,
      exact: true,
    },
    {
      to: `${resolvedBase}/khatabook`,
      label: "Khatabook",
      icon: FiBookOpen,
    },
    {
      to: `${resolvedBase}/cashbook`,
      label: "Cashbook",
      icon: FiCreditCard,
    },
    {
      to: `${resolvedBase}/projects`,
      label: "Project Ledger",
      icon: FiLayers,
    },
    {
      to: `${resolvedBase}/leases`,
      label: "Lease Management",
      icon: FiKey,
    },
  ];

  const isTabActive = (item) => {
    if (item.exact) {
      return currentPath === item.to || currentPath === `${item.to}/`;
    }
    return currentPath === item.to || currentPath.startsWith(`${item.to}/`);
  };

  return (
    <div className="tools-header">
      <div className="tools-header__top">
        <div className="tools-header__title-group">
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {actions && <div className="tools-header__actions">{actions}</div>}
      </div>

      <nav className="tools-nav-tabs" aria-label="Tools Navigation">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isTabActive(item);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`tools-nav-tab ${active ? "active" : ""}`}
            >
              <Icon size={16} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default ToolsHeader;
